import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-stone-50 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-164" data-mp="1j9gz2sqezjay">
      <div className="mx-auto max-w-3xl px-4" data-id="element-165" data-mp="1nbbzlv0itsno">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-emerald-950 sm:text-4xl" data-id="element-166" data-mp="1ncn3dutyv0es">
          Elige tu pack
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-amber-500 bg-white shadow-2xl shadow-stone-900/15" data-id="element-167" data-mp="1x8gmjx26xs5j">
          <div className="h-2 w-full bg-amber-500" aria-hidden="true" data-id="element-168" data-mp="227b5cz05rgpn" />
          <div className="p-6 sm:p-10" data-id="element-169" data-mp="2vqrvd400ex3">
            <span className="inline-flex items-center gap-2 rounded-md bg-emerald-800 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-amber-300" data-id="element-170" data-mp="2ws4hm0nx9gx">
              <TrophyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="1mhg9ejjjj39k" /> Oferta principal
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-stone-100 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-172" data-mp="1hodfgaauprsu">
              <div data-id="element-173" data-mp="1coim803lsq4m">
                <h3 className="text-2xl font-extrabold leading-tight text-emerald-950" data-id="element-174" data-mp="17s217erparvr">{productShortName}</h3>
                <p className="mt-2 text-sm text-stone-700" data-id="element-175" data-mp="25g2bo1qsn0f2">
                  Los {totalVolumes} tomos + {totalBonuses} bonos estratégicos listos para usar en el aula.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-176" data-mp="1vgl7jor6wul7">
                <span className="text-sm text-stone-700" data-id="element-177" data-mp="1vj7epna6582w">
                  Precio regular: <span className="line-through" data-id="element-178" data-mp="1rf84tnje97ii">{priceBefore}</span>
                </span>
                <p className="mt-1 flex items-baseline gap-2 sm:justify-end" data-id="element-179" data-mp="k3r5sr4rxkev">
                  <span className="text-sm font-bold uppercase text-stone-700" data-id="element-180" data-mp="fzjecm6xlqcy">Hoy:</span>
                  <span className="font-serif text-5xl font-extrabold tracking-tight text-emerald-900" data-id="element-181" data-mp="hhi237p7gmge">{price}</span>
                </p>
                <p className="mt-2 inline-block rounded-md border border-amber-500 bg-amber-100 px-2.5 py-1 text-xs font-extrabold uppercase tracking-[.14em] text-stone-900" data-id="element-182" data-mp="mgcm2cywsh23">
                  Más del 50% de descuento
                </p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-183" data-mp="3uvmrnv20c4em">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-emerald-950" data-id="element-184" data-mp="3j1ttcbp2nw5">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-700" aria-hidden="true" data-id="element-185" data-mp="3kzt4ziukquj4" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-186" data-mp="3bxk0papwfxe6">
              Quiero el Megapack
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-stone-800" data-id="element-187" data-mp="2xb3g16bbyzlm">
              <span className="inline-flex items-center gap-1.5" data-id="element-188" data-mp="2scjomqdywvlv">
                <LockIcon className="h-4 w-4 text-emerald-700" aria-hidden="true" data-id="element-189" data-mp="2sed0ck3fu60q" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-190" data-mp="31cyem31vmyvp">
                <ZapIcon className="h-4 w-4 text-emerald-700" aria-hidden="true" data-id="element-191" data-mp="31et0bjkz2v0u" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-192" data-mp="3baw1am438nm7">
                <ShieldCheckIcon className="h-4 w-4 text-emerald-700" aria-hidden="true" data-id="element-193" data-mp="3bacrjsold5j9" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-stone-700" data-id="element-194" data-mp="3l0xrbjg04g3r">
              Pagas en USD. Tu plataforma de pago muestra la conversión a tu moneda local automáticamente.
            </p>
          </div>
        </article>
      </div>
    </section>;
}